module.exports = __webpack_public_path__ + "static/media/jessica_lemos_tuno.e66ee1e4.jpg";